module.exports = __webpack_public_path__ + "static/media/dentist-profile-img.47081b45.jpg";